export default function initSearchForm() {
  handleSearchGTMEvents();
  toggleHideLabelClass();
}

function toggleHideLabelClass() {
  $("#s").on("input", function () {
    if ($(this).val() && !$(".field-wrap").hasClass("hideLabel")) {
      $(".field-wrap").addClass("hideLabel");
    }

    if (!$(this).val()) {
      $(".field-wrap").removeClass("hideLabel");
    }
  });

  let timer;

  $("#searchFormGeolocated").on("submit", function (e) {
    e.preventDefault();

    const val = $(e.target).find('input[name="s"]').val();

    if (val) {
      timer = setInterval(() => {
        if ($(".gtm-search-link").length) {
          clearInterval(timer);
          window.open($(".gtm-search-link")[0].getAttribute("href"), "_self");
        }
      }, 500);
    } else {
      window.open(
        $(e.target).find(".js-search-form-button").data("url"),
        "_self"
      );
    }
  });
}

function handleSearchGTMEvents() {
  $(".search-form input").on("keydown", (e) => {
    if (e.keyCode === 13) {
      dataLayer.push({
        event: "searchEnterKey",
        searchText: e.target.value,
      });
    }
  });
}
